import { render, staticRenderFns } from "./ButtonGlobalStyleV2.vue?vue&type=template&id=b79d2fd6"
import script from "./ButtonGlobalStyleV2.vue?vue&type=script&lang=js"
export * from "./ButtonGlobalStyleV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports